<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Compare Driver Profiles</span><br/>
      <span style="font-style: italic; font-size: 18px">compare key driver fields across your Avatar, Telematics and Booking platforms</span>
    </div>

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 30px" class="d-flex align-items-center justify-content-center">
      <b-button @click.prevent="load_profile_data()" size="lg" variant="success">Compare Driver Profiles</b-button>
    </div>

    <div v-if="!loading && summary" style="text-align: left; margin:20px 20px 0px 20px; color: #666;">

      <div>
        <div @click="toggle_div(toggle, 'af_vs_tbn_diffs')" style="color: steelblue; font-weight: bold; font-size: 24px;">&#8594; Avatar vs. TBN: {{tbn_items.length}} differences found
          <b-button variant="success" size="sm" @click="update_all_tbn_drivers()">Update All In TBN</b-button>
        </div>
        <br/>
        <div :style="toggle.af_vs_tbn_diffs ? 'margin-left: 40px' : 'display:none'">
          <b-table
            :busy="loading"
            sticky-header="70vh"
            bordered
            :items="tbn_items"
            :fields="af_tbn_fields"
            primary-key="id"
            style="font-size:20px"
            :current-page="currentPage"
            :per-page="perPage">

            <template slot="tbn_license_number" slot-scope="row">
              {{row.item.tbn_license_number | trim(15)}}
            </template>
            
            <template slot="actions" slot-scope="row">
              <b-button variant="success" size="sm" @click="update_tbn_driver(row.item)">Update TBN</b-button>
            </template>

          </b-table>
          <b-row>
            <b-col>
              <b-pagination
                v-model="currentPage"
                :total-rows="tbn_items.length"
                :per-page="perPage"
                align="center">
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
      <hr/><br/>
      <div>
        <div @click="toggle_div(toggle, 'af_vs_samsara_diffs')" style="color: steelblue; font-weight: bold; font-size: 24px;">&#8594; Avatar vs. Samsara: {{samsara_items.length}} differences found</div>
        <br/>
        <div :style="toggle.af_vs_samsara_diffs ? 'margin-left: 40px' : 'display:none'">
          <b-table
            :busy="loading"
            sticky-header="70vh"
            bordered
            :items="samsara_items"
            :fields="af_sam_fields"
            primary-key="id"
            style="font-size:20px"
            :current-page="currentPage"
            :per-page="perPage">

            <template slot="actions" slot-scope="row">
              <b-button variant="success" size="md" @click="" disabled>Update Samsara</b-button>
            </template>

          </b-table>
          <b-row>
            <b-col>
              <b-pagination
                v-model="currentPage"
                :total-rows="samsara_items.length"
                :per-page="perPage"
                align="center">
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <div v-else-if="loading">
      <b-spinner class="align-middle"></b-spinner>
    </div>
  </div>
</template>

<script>
import { tbn_update_tbn_driver, tbn_update_all_tbn_drivers, tbn_get_compare_driver_profile_results } from '../networking/tbn_apis'
import { mapState } from "vuex";
import moment from 'moment'

export default {
  name: 'compare_driver_profiles',
  components: {},
  data() {
    return {
      toggle: {},
      tbn_items: [],
      samsara_items: [],
      _items: [],
      summary: null,
      loading: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 40,
      pages: [],
      fields_all: [],
      af_tbn_fields: [
        { key: 'name', label: 'Driver', sortable: true },
        { key: 'af_status', label: 'AF Status', sortable: true },
        { key: 'tbn_status', label: 'TBN Status', sortable: true },
        { key: 'af_license_number', label: 'AF License #', sortable: true },
        { key: 'tbn_license_number', label: 'TBN License #', sortable: true },
        { key: 'af_med_card_expires_on', label: 'AF Med Card Exp', sortable: true },
        { key: 'tbn_med_card_expires_on', label: 'TBN Med Card Exp', sortable: true },
        { key: 'af_license_expires_on', label: 'AF License Exp', sortable: true },
        { key: 'tbn_license_expires_on', label: 'TBN Licence Exp', sortable: true },
        { key: 'actions', label: '', sortable: true },
      ],
      af_sam_fields: [
        { key: 'name', label: 'Driver', sortable: true },
        { key: 'af_status', label: 'AF Status', sortable: true },
        { key: 'samsara_status', label: 'Samsara Status', sortable: true },
        { key: 'af_license_number', label: 'AF License #', sortable: true },
        { key: 'samsara_license_number', label: 'Samsara License #', sortable: true },
        // { key: 'actions', label: '', sortable: true },
      ],
    }
  },
  async created() {
    this.fields_all = this.fields;
  },
  methods: {
    toggle_div(item, field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    async load_profile_data() {
      this.loading = true;
      this.tbn_items = [];
      this.samsara_items = [];

      try {
        const {value: {data = []}} = await tbn_get_compare_driver_profile_results(this.user.tenant);
        this.tbn_items = data.tbn_results;
        this.samsara_items = data.samsara_results;
        this.summary = data.summary;
        //moment.tz.setDefault(this.summary.timezone);
      } catch (e) {
        this.$emit('showAlert', 'Error retrieving data, try logging in again or contact support if needed', 'danger', 5000);
      }
      this.loading = false;
    },
    async update_all_tbn_drivers() {
      if (confirm("Are you sure you want to update all drivers?")) {
        try {
          this.$emit('showAlert', "Updating All TBN drivers", 'info');
          const response = await tbn_update_all_tbn_drivers(this.user.tenant, this.tbn_items);
          const message = (response && response.message) || 'Drivers updated successfully!';
          this.$emit('showAlert', "Updated All TBN drivers", 'success', 1500);
        } catch (e) {
          this.$emit('showAlert', 'Error updating TBN drivers', 'danger', 5000);
        }
      }
    },
    async update_tbn_driver(record) {
      try {
        this.$emit('showAlert', "Updating TBN driver", 'info');
        const response = await tbn_update_tbn_driver(this.user.tenant, record);
        const message = (response && response.message) || 'Driver updated successfully!';
        this.tbn_items = this.tbn_items.filter(item => item.id !== record.id)

        this.$emit('showAlert', message, 'success', 1500);
      } catch (e) {
        this.$emit('showAlert', 'Error updating TBN driver.', 'danger', 5000);
      }
    },
  },
  computed: {
    ...mapState({
      user: state => state.profile.user
    }),
  }
}
</script>

<style>
</style>
